import React from "react";
import { Box, Grid, Container, Typography } from "@mui/material";
import {
  antivirus1,
  aubank,
  axisB,
  duns1,
  facebook,
  hdfcB,
  idfcB,
  indus,
  insta,
  iso1,
  iso2,
  linkdin,
  lockicon,
  loginPage1,
  pnbB,
  rblB,
  sbiB,
  ssl1,
  suryoday,
  telegram,
  threads,
  twitter,
  ujjivanb,
  vapt1,
  whatsapp,
  yesbankB,
  youtube,
} from "../iconsImports";
import { useNavigate } from "react-router-dom";
import {
  getFirmAddress,
  getFirmContact,
  getFirmEmail,
} from "../theme/setThemeColor";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#f6f3f3",
        py: 4,
        position: "relative",
        textAlign: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundImage: `url(${loginPage1})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "650px", // Large watermark
          opacity: 0.08, // Subtle watermark effect
          top: 0,
          left: 0,
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={4}>
          {/* ================= TOP SECTION ================= */}
          <Grid item xs={12}>
            <Grid container spacing={4} justifyContent="space-between">
              {/* Left Section */}
              <Grid item xs={12} md={5} textAlign="left">
                <Box>
                  <img
                    src={loginPage1}
                    alt="logo"
                    width="200px"
                    style={{
                      borderRadius: "6px",
                      padding: "4px",
                    }}
                  />

                  <Typography variant="body1" sx={{ mt: 2, color: "#555" }}>
                    {getFirmAddress()}
                  </Typography>

                  <Typography variant="body1" sx={{ mt: 2, color: "#555" }}>
                    Customer Support Timings: 08:00 AM to 10:00 PM (All Days)
                  </Typography>
                </Box>
              </Grid>

              {/* Right Section */}
              <Grid item xs={12} md={7} sx={{ mt: 1 }}>
                <Grid container spacing={4}>
                  {/* Company Section */}
                  <Grid item xs={12} sm={3}>
                    <Typography
                      variant="h6"
                      sx={{ textAlign: "left", fontWeight: "bold", mb: 2 }}
                    >
                      Company
                    </Typography>

                    <Typography
                      className="text-style"
                      onClick={() => navigate("/")}
                      sx={{ cursor: "pointer" }}
                    >
                      Home
                    </Typography>

                    <Typography
                      className="text-style"
                      onClick={() => navigate("/about-us")}
                      sx={{ cursor: "pointer" }}
                    >
                      About Us
                    </Typography>

                    <Typography
                      className="text-style"
                      onClick={() => navigate("/contact-us")}
                      sx={{ cursor: "pointer" }}
                    >
                      Contact Us
                    </Typography>
                  </Grid>

                  {/* Services */}
                  <Grid item xs={12} sm={3}>
                    <Typography
                      variant="h6"
                      sx={{ textAlign: "left", fontWeight: "bold", mb: 2 }}
                    >
                      Services
                    </Typography>

                    <Typography
                      className="text-style"
                      onClick={() => navigate("/LandingPageRecharge")}
                      sx={{ cursor: "pointer" }}
                    >
                      Recharge
                    </Typography>

                    <Typography
                      className="text-style"
                      onClick={() => navigate("/LandingPageBbps")}
                      sx={{ cursor: "pointer" }}
                    >
                      BBPS
                    </Typography>
                  </Grid>

                  {/* Policies */}
                  <Grid item xs={12} sm={3}>
                    <Typography
                      variant="h6"
                      sx={{ textAlign: "left", fontWeight: "bold", mb: 2 }}
                    >
                      Policies
                    </Typography>

                    <Typography
                      className="text-style"
                      onClick={() => window.open("/terms-conditions", "_blank")}
                      sx={{ cursor: "pointer" }}
                    >
                      Terms & Conditions
                    </Typography>

                    <Typography
                      className="text-style"
                      onClick={() => window.open("/privacy-policy", "_blank")}
                      sx={{ cursor: "pointer" }}
                    >
                      Privacy Policy
                    </Typography>

                    <Typography
                      className="text-style"
                      onClick={() => window.open("/refund-policy", "_blank")}
                      sx={{ cursor: "pointer" }}
                    >
                      Refund Policy
                    </Typography>

                    <Typography
                      className="text-style"
                      onClick={() => window.open("/cancel-policy", "_blank")}
                      sx={{ cursor: "pointer" }}
                    >
                      Cancellation Policy
                    </Typography>
                  </Grid>

                  {/* Contact */}
                  <Grid item xs={12} sm={3}>
                    <Typography
                      variant="h6"
                      sx={{ textAlign: "left", fontWeight: "bold", mb: 2 }}
                    >
                      Contact Us
                    </Typography>

                    <Typography sx={{ textAlign: "left" }}>
                      {getFirmContact()}
                    </Typography>

                    <Typography sx={{ textAlign: "center" }}>
                      01145794784
                    </Typography>

                    <Typography sx={{ textAlign: "left" }}>
                      {getFirmEmail()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      {/* ================= LOWER INFO SECTION ================= */}
      <Box
        sx={{
          borderTop: "1px solid #d9d9d9",
          mt: 4,
          pt: 3,
        }}
      >
        <Grid
          container
          spacing={3}
          alignItems="flex-start"
          justifyContent="space-between"
        >
          {/* ================= MAP ================= */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                overflow: "hidden",
                borderRadius: "12px",
                border: "1px solid #dcdcdc",
                height: { xs: "180px", md: "220px" },
                width: "100%",
              }}
            >
              <iframe
                title="Rohini Sector 24 Map"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                src="https://maps.google.com/maps?q=Rohini%20Sector%2024%20New%20Delhi&t=&z=14&ie=UTF8&iwloc=&output=embed"
              />
            </Box>
          </Grid>

          {/* ================= COMPANY DETAILS ================= */}
          <Grid item xs={12} md={8}>
            <Grid container spacing={4}>
              {/* COLUMN 1 */}
              <Grid item xs={12} sm={6}>
                {/* <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "22px",
                    mb: 2,
                    textAlign: "left",
                    color: "#111",
                  }}
                >
                  Mca No-
                </Typography> */}

                {[
                  "MCA Regn. No: 434664",
                  "PAN NO: AALCD0212B",
                  "GST NO: 07AALCD0212B1ZE",
                  "TAN NO: DELD30980F",
                  "TM NO DETAILS: 689176",
                ].map((item, idx) => (
                  <Typography
                    key={idx}
                    sx={{
                      fontSize: "15px",
                      mt: 2,
                      color: "#222",
                      mb: 1.5,
                      lineHeight: 1.5,
                      textAlign: "left",
                    }}
                  >
                    {item}
                  </Typography>
                ))}
              </Grid>

              {/* COLUMN 2 */}
              <Grid item xs={12} sm={6}>
                <Box sx={{ mt: { xs: 0, sm: 6 } }}>
                  {[
                    "DUNS NO: 756**1101",
                    "ESI Regn No: 10001485920000999",
                    "EPFO No: DLCPM3345358000",
                    "LIN/SPS No: 1-4711-3201-3",
                  ].map((item, idx) => (
                    <Typography
                      key={idx}
                      sx={{
                        fontSize: "15px",
                        color: "#222",
                        mb: 1.5,
                        lineHeight: 1.5,
                        textAlign: "left",
                      }}
                    >
                      {item}
                    </Typography>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          width: "100%",
          mt: 2,
          pt: 2,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          borderTop: "1px solid #e5e5e5",
        }}
      >
        {/* COPYRIGHT */}
        <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
          <Typography
            sx={{
              fontSize: { xs: "13px", md: "15px" },
              color: "#222",
              fontWeight: 500,
            }}
          >
            © Copyright 2024{" "}
            <span
              style={{
                fontWeight: 700,
                letterSpacing: "0.5px",
              }}
            >
              DILLIPAY TECHNOLOGIES LIMITED
            </span>
            . All Rights Reserved.
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "12px", md: "14px" },
              color: "#444",
              mt: 0.5,
            }}
          >
            Disclaimer: Any dispute arising shall be subject to the jurisdiction
            of the courts of Delhi.
          </Typography>
        </Box>

        {/* SOCIAL ICONS */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {[
            facebook,
            linkdin,
            twitter,
            insta,
            youtube,
            telegram,
            whatsapp,
            threads,
          ].map((icon, idx) => (
            <Box
              key={idx}
              sx={{
                width: "38px",
                height: "38px",
                borderRadius: "50%",
                overflow: "hidden",
                cursor: "pointer",
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-3px)",
                },
              }}
            >
              <img
                src={icon}
                alt="social"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
